import type { StrictOmit } from '@frontend/duck-tape';
import type { IconProps } from '../Primitives';
import { Icon, Text, Title, XStack, YStack } from '../Primitives';
import type { IconName } from '../Primitives/Icon/helpers';

export type PaneProps = {
  children?: Children;
  className?: string;
  description: string;
  enableBackgroundColor?: boolean;
  iconName?: IconName;
  iconProps?: StrictOmit<IconProps, 'name'>;
  title: string;
  uppercaseTitle?: boolean;
};

export const Pane = ({
  children,
  className = 'flex-1 pb-xxxl',
  description,
  enableBackgroundColor = false,
  iconName = 'IconBarrierBlock',
  iconProps,
  title,
  uppercaseTitle = true,
}: PaneProps) => {
  return (
    <YStack alignItems="center" className={className} gapY="md" justifyContent="center">
      {iconName ? (
        <XStack>
          <Icon
            className="p-sm"
            enableBackgroundColor={enableBackgroundColor}
            name={iconName}
            rounded
            size="xl"
            {...iconProps}
          />
        </XStack>
      ) : null}
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack alignItems="center" className="max-w-[50%]" gapY="md">
        <Title textAlign="center" type="h1" uppercase={uppercaseTitle}>
          {title}
        </Title>
        <Text textAlign="center" type="h5">
          {description}
        </Text>
        {children}
      </YStack>
    </YStack>
  );
};
